module.exports = __webpack_public_path__ + "static/img/login-logo.e8bea93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-logo.png
// module id = nkOi
// module chunks = 23